import { type FunctionComponent } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useScrollPositionHandler } from '../hooks/routing/scroll-position-handler.hook';
import { generatedRoutes } from '../routes/generated-routes';
import { ApplicationObserver } from './layouts/application-observer/application-observer.component';
import { RouteWithLayout } from './layouts/routed/routed-with-layout.component';
import '../styles/global-tw.css';
import '../styles/global.css';
import { StyleLoader } from './style-loader/style-loader.component';

export const App: FunctionComponent = () => {
	useScrollPositionHandler();
	const appRoutes = generatedRoutes.map((props) => {
		const path = props.path;
		return <Route path={path} key={props.path} element={<RouteWithLayout {...props} />}></Route>;
	});
	return (
		<StyleLoader>
			<ApplicationObserver>
				<Routes>{appRoutes}</Routes>
			</ApplicationObserver>
		</StyleLoader>
	);
};
